import { render, staticRenderFns } from "./artificialPaper.vue?vue&type=template&id=3913fc35&scoped=true&"
import script from "./artificialPaper.js?vue&type=script&lang=js&"
export * from "./artificialPaper.js?vue&type=script&lang=js&"
import style0 from "./artificialPaper.vue?vue&type=style&index=0&id=3913fc35&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3913fc35",
  null
  
)

export default component.exports